import { Directive, ElementRef, HostListener, Input } from '@angular/core';

@Directive({
  selector: '[drAmount]'
})
export class AmountDirective {
  @Input('drAmount') language: string;
  @HostListener('keydown') onKeyDown() {
    this.el.nativeElement.value = this.el.nativeElement.value.replace(/(?!([\d\.\,]))./g, '');
  }
  @HostListener('change') onChange() {
    if (!!this.el.nativeElement.value) {
      if (['it', 'it-IT'].includes(this.language)) {
        let val = this.el.nativeElement.value;
        val = val.replace(/(?!([\d\.\,]))./g, '');
        if (val.includes(',')) {
          let d = val.split(',');
          d[0] = d[0].replace(/\./g, '').replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.');
          d[1] = Number('0.' + d[1].replace(/\D/g, '')).toFixed(2).substr(2);
          val = d[0] + ',' + d[1];
        } else {
          val = this.el.nativeElement.value.replace(/\./g, '').replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.');
        }
        this.setValue(val);
      } else {
        this.setValue(this.el.nativeElement.value.split(',').join(''));
      }
      // this.el.nativeElement.valueAsNumber = Number(this.el.nativeElement.value);
    }
  }

  setValue(value: string) {
    value = value.replace(/(?!([\d\.\,]))./g, '');
    this.el.nativeElement.value = value;
    // setTimeout(() => {
    //   var evt = document.createEvent('change');
    //   evt.initEvent("change", false, true);
    //   this.el.nativeElement.dispatchEvent(evt);
    // }, 500);
  }

  @HostListener('submit') onSubmit() {

  }

  constructor(private el: ElementRef<HTMLInputElement>) {

  }

}
